import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
// TODO: move to /entities/seat-map/ui
import SeatPrice from '../../../../../SeatMap/components/SeatPrice/SeatPrice';
const Passenger = ({ className, classes, index, label, seats, price, seatsIcon }) => {
    const { Passenger: css } = useTheme('Entities').SeatMap;
    const { t } = useTranslation('SeatMap');
    return (React.createElement("div", { className: cn(css.wrapper, className) },
        React.createElement("div", { className: css.main },
            React.createElement("div", { className: cn(css.index, classes.index) }, index),
            React.createElement("div", { className: cn(css.label, classes.label) }, label)),
        seats ? (React.createElement("div", { className: css.payload },
            React.createElement("div", { className: cn(css.seats, classes.seats) }, seats),
            price ? (React.createElement(SeatPrice, { className: css.seatPrice, moneyClassName: cn(css.money, classes.money), money: price })) : (React.createElement("span", { className: cn(css.freeSeat, classes.freeSeat) }, t('Free seat'))),
            seatsIcon)) : (React.createElement("div", { className: cn(css.payload, css.select, classes.select) }, t('Select')))));
};
export default Passenger;
